// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.toast[data-v-26cb95c0] {

    display: flex;

    align-items: center;

    -moz-column-gap: 0.75rem;

         column-gap: 0.75rem;

    --tw-text-opacity: 1;

    color: rgb(22 22 22 / var(--tw-text-opacity))
}
.toast > button[data-v-26cb95c0] {

    margin-left: 1rem;

    min-width: 0px !important;

    border-radius: 6px;

    border-width: 1px;

    --tw-border-opacity: 1;

    border-color: rgb(255 255 255 / var(--tw-border-opacity));

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity))
}
.toast > button[data-v-26cb95c0]:hover {

    --tw-border-opacity: 1;

    border-color: rgb(255 255 255 / var(--tw-border-opacity));

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity))
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/toasts/Toast.vue"],"names":[],"mappings":";AA0DA;;IAAA,aAAA;;IAAA,mBAAA;;IAAA,wBAAA;;SAAA,mBAAA;;IAAA,oBAAA;;IAAA;AAAA;AAGA;;IAAA,iBAAA;;IAAA,yBAAA;;IAAA,kBAAA;;IAAA,iBAAA;;IAAA,sBAAA;;IAAA,yDAAA;;IAAA,oBAAA;;IAAA;AAAA;AAAA;;IAAA,sBAAA;;IAAA,yDAAA;;IAAA,oBAAA;;IAAA;AAAA","sourcesContent":["<template>\n  <div class=\"toast\">\n    <Icon :name=\"iconName\" :size=\"18\" :color=\"NEUTRAL_SUPERDARK\" />\n    <span v-html=\"title\"></span>\n    <Button v-if=\"action && label\" btnStyle=\"secondary\" size=\"md\" @click.stop=\"$emit(action, $event)\">{{ label }}</Button>\n  </div>\n</template>\n\n<script>\nimport { computed } from '@vue/composition-api';\nimport { getColor } from '@/lego/utils/tailwind/config';\nimport Button from '@/lego/components/buttons/Button.vue';\nimport Icon from '@/lego/components/icons/Icon.vue';\n\nconst NEUTRAL_SUPERDARK = getColor('neutral.superdark');\n\nexport default {\n  components: { Button, Icon },\n  props: {\n    title: {\n      type: String,\n      required: true,\n    },\n    action: {\n      type: String,\n      default: null,\n    },\n    label: {\n      type: String,\n      default: null,\n    },\n    type: {\n      type: String,\n      required: true,\n    },\n  },\n  setup(props) {\n    return {\n      NEUTRAL_SUPERDARK,\n      iconName: computed(() => {\n        switch (props.type) {\n          case 'success':\n            return 'success';\n          case 'error':\n            return 'cross';\n        }\n      }),\n    };\n  },\n};\n</script>\n\n<style lang=\"postcss\">\n@import 'vue-toastification/dist/index.css';\n</style>\n\n<style lang=\"postcss\" scoped>\n.toast {\n  @apply flex items-center gap-x-micro text-neutral-superdark;\n\n  & > button {\n    @apply ml-xxxs border-neutral-white text-neutral-white hover:text-neutral-white hover:border-neutral-white rounded-s border-hairline !min-w-0;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
